import React from "react";
import { NavItemDefault } from "./components/_NavItemDefault";
import { NavItemStacked } from "./components/_NavItemStacked";
import { NavItemProps } from "./types";

export const NavItem = (props: NavItemProps) => {
  if (props?.variant === "stacked") return <NavItemStacked {...props} />
  return <NavItemDefault {...props} />
}